import { Outside } from '@cian/ui-kit';
import styles from './DropdownFilter.css';
import { FC, useCallback, useRef } from 'react';
import { FilterButton, TButtonStyle } from '../FilterButton';
import { DropdownContainer } from './components';
import { SearchResultsTooltip } from '../SearchResultsTooltip';
import { FilterButtonV2 } from '../FilterButtonV2';
import { IconActionChevronDownSmall16 } from '@cian/ui-kit-design-tokens/icons';
import { TButtonSize } from 'shared/types/filters';

interface IDropdownFilterProps {
  showTooltip?: boolean;
  opened: boolean;
  buttonLabel: string;
  buttonStyle?: TButtonStyle;
  dropdownContent: React.ReactNode;
  isFiltersRedesignEnabled: boolean;
  size?: TButtonSize;

  onOpen: VoidFunction;
  onClose: VoidFunction;
}

export const DropdownFilter: FC<IDropdownFilterProps> = ({
  showTooltip,
  buttonStyle,
  buttonLabel,
  dropdownContent,
  opened,
  isFiltersRedesignEnabled,
  size,
  onOpen,
  onClose,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const handleToggle = useCallback(() => {
    if (opened) {
      onClose();
    } else {
      onOpen();
    }
  }, [onClose, onOpen, opened]);

  return (
    <Outside onOutside={onClose} active={opened}>
      <div className={styles['container']} ref={containerRef}>
        <SearchResultsTooltip open={showTooltip && !opened} placement="bottom-start">
          {isFiltersRedesignEnabled ? (
            <FilterButtonV2
              afterIcon={<IconActionChevronDownSmall16 color="icon-main-default" />}
              onClick={handleToggle}
              size={size}
            >
              {buttonLabel}
            </FilterButtonV2>
          ) : (
            <FilterButton onClick={handleToggle} buttonStyle={buttonStyle}>
              {buttonLabel}
            </FilterButton>
          )}
        </SearchResultsTooltip>
        {opened && (
          <SearchResultsTooltip open={showTooltip} placement="right" onApplyClick={onClose}>
            <DropdownContainer>{dropdownContent}</DropdownContainer>
          </SearchResultsTooltip>
        )}
      </div>
    </Outside>
  );
};
